import React, { useEffect, useState } from 'react';
import { Button, Field, Input, Message, Modal, Toast } from 'react-frontier';
import { SetLoading, UserClass } from '../SiteClasses';
import moment from 'moment';
import API from '../API';
import Validator from '../Validator';
import SearchUserModal from './SearchUserModal';

interface CoordinatorBudgetsReportModalProps{
	open: boolean;
	onClose: ()=>void;
}

interface ReportForm{
	user_id: number;
	user_name: string;
	date_start: number;
	date_end: number;
}

var CoordinatorBudgetsReportModal = (props: CoordinatorBudgetsReportModalProps)=>{
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var [userModal, setUserModal] = useState<boolean>(false);
	var [form, setForm] = useState<ReportForm>({
		user_id: null,
		user_name: null,
		date_start: null,
		date_end: null,
	});

	useEffect(()=>{
		if(props.open){
			setModalPrompts(null);
			setForm({ user_id: null, user_name: null, date_start: null, date_end: null });
		}
	}, [props.open]);

	var onUserSelected = (user: UserClass)=>{
		setForm(prev => ({
			...prev,
			user_id: user.user_id,
			user_name: `${user.first_name} ${user.last_name}`,
		}));
		setUserModal(false);
	};

	var onDownload = (setLoading: SetLoading)=>{
		var { valid, prompts } = Validator(form, {
			user_id: [{ rule: 'empty', label: 'Coordinador' }],
			date_start: [{ rule: 'empty', label: 'Fecha inicio' }],
			date_end: [{ rule: 'empty', label: 'Fecha fin' }],
		});
		setModalPrompts(prompts);
		if(!valid) return;
		if(form.date_end <= form.date_start) return setModalPrompts(['La fecha de fin debe ser mayor que la fecha de inicio.']);

		setLoading(true);
		var dateStart = moment.unix(form.date_start).startOf('day').unix();
		var dateEnd = moment.unix(form.date_end).endOf('day').unix();

		API.downloadCoordinatorBudgetsReport(form.user_id, dateStart, dateEnd).then((res: any)=>{
			if(res && res.error) return setModalPrompts([res.message]);
			Toast.success('Reporte descargado correctamente.');
			
			props.onClose();
		}).catch(()=>{
			setModalPrompts(['Hubo un error inesperado generando el reporte. (CBRM-2)']);
		}).finally(()=>{
			setLoading(false);
		});
	};

	return (
		<>
			<Modal open={props.open} onClose={props.onClose} size='tiny'>
				<Modal.Header>Reporte por coordinador</Modal.Header>
				<Modal.Content>
					<Field label='Coordinador'>
						<Input
							value={form.user_name}
							placeholder='Selecciona un coordinador...'
							readonly
							button={
								<Button
									text='Seleccionar'
									onClick={()=> setUserModal(true)}
								/>
							}
						/>
					</Field>
					<Field amount={2} style={{ marginTop: 10 }}>
						<Input
							label='Fecha inicio'
							value={form.date_start}
							onChange={(v: number) => setForm(prev => ({ ...prev, date_start: v }))}
							style={{ width: '100%' }}
							calendar={{
								date: form.date_start || moment().startOf('month').unix(),
								mode: 'date',
								format: 'DD/MM/YYYY',
							}}
						/>
						<Input
							label='Fecha fin'
							value={form.date_end}
							onChange={(v: number) => setForm(prev => ({ ...prev, date_end: v }))}
							style={{ width: '100%' }}
							calendar={{
								date: form.date_end || moment().endOf('month').unix(),
								mode: 'date',
								format: 'DD/MM/YYYY',
							}}
						/>
					</Field>
					{form.user_name && form.date_start && form.date_end && (
						<Message
							type='info'
							text={`Se generará el reporte de ${form.user_name} del ${moment.unix(form.date_start).format('DD/MM/YYYY')} al ${moment.unix(form.date_end).format('DD/MM/YYYY')}.`}
						/>
					)}
					<Message type='error' list={modalPrompts} />
				</Modal.Content>
				<Modal.Actions>
					<Button basic text='Cancelar' onClick={props.onClose} />
					<Button color='black' text='Descargar' iconName='download' onClick={onDownload} />
				</Modal.Actions>
			</Modal>
			<SearchUserModal
				open={userModal}
				onClose={()=> setUserModal(false)}
				onSelected={onUserSelected}
				title='Seleccionar coordinador'
			/>
		</>
	);
};

export default CoordinatorBudgetsReportModal;
